import { hasLocizeTranslation } from 'lib/utils/locize'

/**
 * @param {function} t              - The translate function of locize
 * @param {object} item             - The word item that contains its locize key, disabled key, fallback word
 * @param {string} item.value       - The fallback word in case the key not has its word available
 * @param {number} dynamicNumber    - This is a number indicating that we will replace `%d` inside the text with it
 */
const replaceText = (t, item, dynamicNumber = false) => {
  const translatedString = hasLocizeTranslation(t, item.disabledKey, item.value)
  const replacedText = translatedString.replace(/(\\n)/g, '\n')

  return item.dynamicNumber && dynamicNumber
    ? replacedText.replace('%d', dynamicNumber)
    : replacedText
}

export default replaceText
